import React from "react";
import { Modal, ModalDialog } from "@mui/joy";
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import ResultsTable from "../../../components/policywizard/ResultsTable";

const TestResultModal = ({ open, onClose, testResult }) => {
  if (!open) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{ zIndex: "10000" }}
    >
      <ModalDialog>
        <Card style={{ overflowY: "auto", height: "fit-content" }}>
          <CardContent>
            {testResult && testResult.testResult && testResult.testResult.answer ? (
              <ResultsTable result={testResult} />
            ) : (
              <Typography level="body-md" color="danger">
                No test result data available.
              </Typography>
            )}
          </CardContent>
        </Card>
      </ModalDialog>
    </Modal>
  );
};

export default TestResultModal;

